//Το σχολίασα επειδή το css για το μενού βρίσκεται στο γενικό css το οποίο φωρτονεται στο main.js
//require('navbar.css');
require('../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/navbar_side.template.htm');
require('dhtmlxMessage');

var TheView = GenericView.extend({
    el: $("#left-panel"),
    tagName: 'aside',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	userData: null,
	numberPrivilegeLevel: null,
	initialize: function (options) {
		this.userData = options.data;
		//console.info(options.data);
		//console.info(this.userData);
		this.numberPrivilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);
        this.render();
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		this.$el.html(this.template( { privilegeLevel : this.numberPrivilegeLevel } ));

	},
	events:{
	}


});


module.exports= TheView;